export function IconAnchor({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      focusable="false"
      aria-hidden="true"
    >
      {/* Anker-Auge (Ring oben) */}
      <circle cx="12" cy="5" r="2" />
      {/* Schaft */}
      <path d="M12 7 V20" />
      {/* Querstrebe oben */}
      <path d="M9 9 H15" />
      {/* Boden-Bogen (Anker-Arme) */}
      <path d="M5 16 C5 19 8 21 12 21 C16 21 19 19 19 16" />
      {/* Widerhaken/Spitzen links */}
      <path d="M5 16 L3 15" />
      <path d="M5 16 L5 14" />
      {/* Widerhaken/Spitzen rechts */}
      <path d="M19 16 L21 15" />
      <path d="M19 16 L19 14" />
    </svg>
  );
}
